import { Component } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'

@Component({
	standalone: true,
	imports: [MatButtonModule],
	selector: 'feature-porto-bank-sandbox',
	template: `
		<div style="display: flex; flex-direction: column; gap: 16px; margin: 32px">
			<p>Stroked</p>
			<button mat-stroked-button color="primary">Cadastrar</button>
			<p>Outlined</p>
			<button mat-outlined-button color="primary">Cadastrar</button>
			<button mat-outlined-button color="primary" disabled>Cadastrar</button>
			<p>Flat</p>
			<button mat-flat-button color="primary">Cadastrar</button>
			<button mat-flat-button color="primary" disabled>Cadastrar</button>
		</div>
	`,
})
export class SandboxComponent {}
